import React from 'react';

import Spinner from '@atlaskit/spinner';

import { useTestCaseRepositoryIssuesContext } from '../../TestCaseRepositoryIssuesProvider';
import { ContainerStyled } from './TotalIssues.styled';

export function TotalIssues(): JSX.Element {
  const { totalIssues, loading } = useTestCaseRepositoryIssuesContext();
  const totalTestCasesLabel = totalIssues === 1 ? 'test case' : `test cases`;

  return (
    <ContainerStyled>
      {loading !== 'none' ? (
        <Spinner />
      ) : (
        `(${totalIssues} ${totalTestCasesLabel})`
      )}
    </ContainerStyled>
  );
}
